import {defineMessages, MessageDescriptor} from 'react-intl'

import {DateValidationReason} from '@vio/core/src/searchParams/dateValidationReason'

export const tooltipMessages = defineMessages({
  datesUpdated: {
    id: 'dateValidation.datesUpdated',
    defaultMessage:
      'We updated your dates to show available results. Double-check before booking.'
  },
  datesTooFarInFuture: {
    id: 'dateValidation.datesTooFarInFuture',
    defaultMessage:
      "We updated your dates because those dates aren't available yet. Double-check before booking."
  },
  stayTooLong: {
    id: 'dateValidation.stayTooLong',
    defaultMessage:
      'We updated your dates to show available results for a shorter stay. Double-check before booking.'
  },
  confirmDates: {
    id: 'confirmDates',
    defaultMessage: 'Remember to double check your dates'
  }
})

/**
 * Maps a DateValidationReason to the appropriate message descriptor.
 * Returns null for None/null (falls back to existing confirmDates message).
 */
export const getTooltipMessage = (
  reason?: DateValidationReason | null
): MessageDescriptor => {
  switch (reason) {
    case DateValidationReason.InvalidFormat:
    case DateValidationReason.DatesInPast:
      return tooltipMessages.datesUpdated
    case DateValidationReason.TooFarInFuture:
      return tooltipMessages.datesTooFarInFuture
    case DateValidationReason.StayTooLong:
      return tooltipMessages.stayTooLong
    default:
      return tooltipMessages.confirmDates
  }
}
